<template>
  <transition name="fade">
    <div v-if="show" class="modern-loader-overlay" @click.self="onOverlayClick">
      <div class="modern-loader-content">
        <!-- Spinner Moderno -->
        <div class="loader-spinner">
          <div class="spinner-ring"></div>
          <div class="spinner-ring"></div>
          <div class="spinner-ring"></div>
          <div class="spinner-logo">
            <i class="ri-stack-line"></i>
          </div>
        </div>

        <!-- Mensaje -->
        <div class="loader-message" v-if="message" v-html="message"></div>

        <!-- Mensaje adicional o descripción -->
        <div class="loader-description" v-if="description" v-html="description">
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'ModernLoader',
  props: {
    message: {
      type: String,
      default: 'Procesando...'
    },
    description: {
      type: String,
      default: ''
    },
    show: {
      type: Boolean,
      default: true
    },
    dismissable: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onOverlayClick() {
      if (this.dismissable) {
        this.$emit('close');
      }
    }
  }
}
</script>

<style scoped>
.modern-loader-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: var(--theme-overlay-bg);
  backdrop-filter: var(--theme-backdrop-blur);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  padding: 2rem;
}

.modern-loader-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.5rem;
  background: var(--theme-bg-card);
  border: 1px solid var(--theme-border-color);
  border-radius: 24px;
  padding: 3rem 2.5rem;
  box-shadow: var(--theme-shadow-xl);
  max-width: 400px;
  width: 100%;
  animation: slideUp 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(30px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

/* Spinner Moderno con Anillos */
.loader-spinner {
  position: relative;
  width: 80px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.spinner-ring {
  position: absolute;
  width: 100%;
  height: 100%;
  border: 3px solid transparent;
  border-radius: 50%;
  animation: spin 2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
}

.spinner-ring:nth-child(1) {
  border-top-color: var(--app-primary-blue);
  animation-delay: -0.45s;
}

.spinner-ring:nth-child(2) {
  border-top-color: rgba(13, 78, 140, 0.5);
  animation-delay: -0.3s;
  width: 85%;
  height: 85%;
}

.spinner-ring:nth-child(3) {
  border-top-color: rgba(13, 78, 140, 0.3);
  animation-delay: -0.15s;
  width: 70%;
  height: 70%;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.spinner-logo {
  position: relative;
  z-index: 1;
  color: var(--app-primary-blue);
  animation: pulse 2s ease-in-out infinite;
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.7;
    transform: scale(0.95);
  }
}

/* Mensajes */
.loader-message {
  font-size: 1.125rem;
  font-weight: 600;
  color: var(--theme-text-primary);
  text-align: center;
  letter-spacing: -0.01em;
}

.loader-description {
  font-size: 0.9375rem;
  color: var(--theme-text-secondary);
  text-align: center;
  line-height: 1.6;
  max-width: 300px;
}

/* Transición de Fade */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-active .modern-loader-content,
.fade-leave-active .modern-loader-content {
  transition: all 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-from .modern-loader-content,
.fade-leave-to .modern-loader-content {
  transform: translateY(30px) scale(0.95);
  opacity: 0;
}

/* Responsive */
@media (max-width: 480px) {
  .modern-loader-content {
    padding: 2.5rem 2rem;
    border-radius: 20px;
  }

  .loader-spinner {
    width: 64px;
    height: 64px;
  }

  .spinner-logo svg {
    width: 28px;
    height: 28px;
  }

  .loader-message {
    font-size: 1rem;
  }

  .loader-description {
    font-size: 0.875rem;
  }
}
</style>
